module.exports = __webpack_public_path__ + "media/images/home/proof_of_income-13f16dd1fa41ef9ac77ba3c2d85b8131.png";